import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getListingsByOwner, publishListing, reinitializeFormData, setListingBookings, reinitializePhotos } from './actions';
import { initListingData } from './constants';
import ListingDetails from './components/Details';
import AvailabilityAndPricing from './components/AvailabilityAndPricing';
import * as qs from 'query-string';
import { canOwnerCreateListing } from './forms/listingFormPreview';
import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';

const mapStateToProps = state => ({
  global: state.Global,
  listings: state.Listing.listingCollection,
  activeListing: state.Listing.listingData,
  formData: state.Listing.formData,
  calendars: state.Listing.calendars,
  dashboard: state.Dashboard,
  user: state.User.user
});

export const onCreateListing = (props) => {
  props.dispatch(reinitializeFormData());
  props.dispatch(reinitializePhotos());
  props.dispatch(setListingBookings([]));
  props.history.push('/dashboard/listing/forms/details')
}


class ManageListingComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentListing: initListingData,
      showDetails: true,
      isCompletingProfile: false
    }
    this.toggleIsActive = this.toggleIsActive.bind(this);
    this.componentDidUpdatePart = this.componentDidUpdatePart.bind(this);
  }

  componentDidUpdatePart(prevProps, prevState) {
    let query = {};
    if (location.search) {
      query = qs.parse(location.search, { ignoreQueryPrefix: true });
    } else if (location.hash.indexOf('?') > -1) {
      query = qs.parse(location.hash.substr(location.hash.indexOf('?')), { ignoreQueryPrefix: true });
    }

    let showDetails = query.view === "ma" ? false : prevState.showDetails;
    showDetails = this.state.currentListing.lastCompleted > 0 && this.state.currentListing.lastCompleted < 10 ? true : showDetails;
    let first = this.props.listings[0];
    if (!this.state.currentListing._id && this.props.activeListing._id) {
      this.setState({ currentListing: this.props.activeListing, showDetails: showDetails });
    } else if (!this.state.currentListing._id && !this.props.activeListing._id) {
      this.setState({ currentListing: first, showDetails: showDetails });
    } else {
      this.setState({ showDetails: showDetails });
      this.props.history.push('?view=details');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((this.props.listings && this.props.listings.length > 0 && typeof this.state.currentListing._id == 'undefined') ||
      (this.state.currentListing !== prevState.currentListing)) {
      this.componentDidUpdatePart(prevProps, prevState)
    }
  }

  componentDidMount() {
    let { global, history, dispatch } = this.props;
    if (!global.userId || !global.token) {
      history.push('/login');
    } else {
      dispatch(getListingsByOwner(global.userId));
    }
  }

  onChange = (e) => {
    let { listings } = this.props;
    let currentListing = listings.find(x => x._id === e.target.value);
    this.setState({ currentListing: currentListing });
  }

  toggleTab = (showDetails) => {
    this.setState({ showDetails: showDetails }, () => {
      if (!this.state.showDetails) {
        this.props.history.push('?view=ma')
      } else {
        this.props.history.push('?view=details')
      }
    });
  }

  toggleIsActive = () => {

    if (this.state.isCompletingProfile)
      return;

    let { dispatch, global, user } = this.props;
    let { currentListing } = this.state;

    if (!canOwnerCreateListing(user, this.props.history, dispatch)) {
      this.setState({
        isCompletingProfile: true
      })
      return;
    }

    let message = this.state.currentListing.isActive ?
      'Are you sure you want to unpublish your listing? This will remove it from all areas of the site and not allow bookings.' :
      'Are you sure you want to publish your listing? This will allow the listing to be browsed on the site and users can initiate the booking process.';
    if (window.confirm(message)) {
      dispatch(publishListing(currentListing._id, !currentListing.isActive))
        .then(() => {
          dispatch(getListingsByOwner(global.userId));
          this.setState({ currentListing: initListingData });
        });
    }
  }

  render() {
    let { listings, isMobile } = this.props;
    let currentListingCompleted = (!this.state.currentListing.lastCompleted || this.state.currentListing.lastCompleted === 10 ||
      this.state.currentListing.lastCompleted === 0);

    if (!listings.length) {
      return (<div>
        <div className="container manage-listing">
          <div className="row pl-3 mb-3">
            {!isMobile && (<h2>Manage Listings</h2>)}
            <button className="ml-auto mr-3 btn btn-secondary" onClick={() => { onCreateListing(this.props) }} type="button">Create New Listing</button>
          </div>
          <div className="row pl-3 mb-2"><h5>No listings created yet!</h5></div>
        </div></div>)
    }
    return (
      <div>
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="container manage-listing">
          <div className="row pl-3 mb-3">
            {!isMobile && (<h2>Manage Listings</h2>)}
            <button className="ml-auto mr-3 btn btn-secondary" onClick={() => { onCreateListing(this.props) }} type="button">Create New Listing</button>
          </div>
          <div className="row pl-3 mb-2 manage-listing-menu">
            <div className="col-md-6 listing-select pl-0 align-tabs">
              <label>
                <select id="current-listing-id" onChange={this.onChange} value={this.state.currentListing._id} className={currentListingCompleted ? "" : "pink"}>
                  {listings && listings.map((listing, i) => {
                    let listingComplete = !listing.lastCompleted || listing.lastCompleted === 10 || listing.lastCompleted === 0;
                    return (<option className={listingComplete ? "" : "pink"} key={i} value={listing._id}>{listingComplete
                      ? listing.address.address1
                      : "[DRAFT] " + listing.address.address1}</option>);
                  })}
                </select>
                <i className="fas fa-angle-down fa-2x"></i>
              </label>
            </div>
            <div className="col pl-0 pr-1 align-tabs" onClick={() => this.toggleTab(true)}>
              <span className={this.state.showDetails ? 'active' : ''}>Listing Details</span>
            </div>
            {currentListingCompleted &&
              <div className="col pl-0 pr-0 align-tabs" onClick={() => this.toggleTab(false)}>
                <span className={!this.state.showDetails ? 'active' : ''}>Availability & Pricing</span>
              </div>
            }
          </div>
          <div className="container">
            {this.state.showDetails ? <ListingDetails {...this.props} listing={this.state.currentListing}
              listingCompleted={currentListingCompleted} toggleIsActive={this.toggleIsActive} /> :
              <AvailabilityAndPricing {...this.props} listing={this.state.currentListing} />
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(ManageListingComponent));
